export const FIELD_CONFIG = {
  autocomplete: {
    characterStart: 3
  }
}